import React from 'react';

export default class SuspendedTag extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="SuspendedTag my-0">
				<span className="tag">{I18n.t('admin.suspended_tag')}</span>
			</div>
		);
	}
}
